export enum MType {
  NEW_ORDER_PLACED = 'NOP',
  ORDER_CONFIRMED = 'OCF',
  ORDER_UPDATED = 'OUP',
  ORDER_ITEM_DECLINED = 'OID',
  ITEM_START_PREPARING = 'ISP',
  ITEM_PREPARED = 'IPD',
  ITEM_PREP_TIME_UPDATED = 'IPT',
  ITEM_SERVED = 'ISR',
  ORDER_SERVED = 'OSR',
  ORDER_COMPLETED = 'OCM',
  ORDER_CANCELED = 'OCL',
  COLLECT_CASH = 'CSH',
  PAYMENT_SUCCESS = 'PAY',
  PAYMENT_FAILED = 'PAY_FAILED',
  USER_MESSAGE = 'USM',
  SERVER_PICKED_ITEM = 'SPI',
  SERVER_SERVED = 'SSR',
  DELIVERY_CALLBACK = 'DCB',
  DELIVERY_STATUS_UPDATED = 'DSU',
  TABLE_UPDATED = 'TUP',
  USER_MESSAGE_ACKNOWLEDGE = 'USMACK',
  NEW_SCHEDULE_ORDER_PLACED = 'NSOP',
  ITEM_PREPARED_FOODCOURT = 'IPF',
  RESV_CREATED = 'RESVCR',
  RESV_ACCEPTED = 'RESVACP',
  RESV_REJECTED = 'RESVRJ',
  RESV_PENDING = 'RESVPD',
  REPORT_GENERATED = 'REPORTGEN',
  RESV_LESS_THAN_5_MINS_REM = 'RESV_LESS_THAN_5_MINS_REM'
}

export enum HqMType {
  REPORT_GENERATED = 'REPORTGEN',
}

export enum Event {
  ORDER_EVENT = 'order-event',
  DELIVERY_EVENT = 'delivery-event',
  TABLE_EVENT = 'table-event',
  TABLE_RESERVATION_EVENT = 'reservation-event',
  REPORTS_EVENT = 'reporting-service-event',
  RESTAURANT_SETTINGS_EVENT = 'restaurant_settings',
  RESTAURANT_DETAILS_EVENT = 'restaurant_details',
}

export enum HqEvent {
  REPORTS_EVENT = 'reporting-service-event',
}

export const msgEvents: any = [
  {
    event: Event.ORDER_EVENT,
    mtypes: [
      MType.NEW_ORDER_PLACED,
      MType.ORDER_CONFIRMED,
      MType.ORDER_UPDATED,
      MType.ORDER_SERVED,
      MType.ORDER_COMPLETED,
      MType.ORDER_CANCELED,
      MType.ORDER_ITEM_DECLINED,
      MType.ITEM_START_PREPARING,
      MType.ITEM_PREPARED,
      MType.ITEM_PREP_TIME_UPDATED,
      MType.ITEM_SERVED,
      MType.PAYMENT_SUCCESS,
    ],
  },
  {
    event: Event.DELIVERY_EVENT,
    mtypes: [MType.DELIVERY_CALLBACK, MType.DELIVERY_STATUS_UPDATED],
  },
  {
    event: Event.TABLE_EVENT,
    mtypes: [
      MType.COLLECT_CASH,
      MType.USER_MESSAGE,
      MType.SERVER_PICKED_ITEM,
      MType.SERVER_SERVED,
    ],
  },
  {
    event: Event.TABLE_RESERVATION_EVENT,
    mtypes: [
      MType.RESV_ACCEPTED,
      MType.RESV_CREATED,
      MType.RESV_PENDING,
      MType.RESV_REJECTED,
      MType.RESV_LESS_THAN_5_MINS_REM
    ],
  },
  {
    event: Event.REPORTS_EVENT,
    mtypes: [MType.REPORT_GENERATED],
  },
];

export const HqMsgEvents: any = [
  {
    event: Event.REPORTS_EVENT,
    mtypes: [MType.REPORT_GENERATED],
  },
];

/* Get all message events */
export const getAllMsgEvents = (): Array<string> => {
  const msg_events = msgEvents;
  const events = [];
  for (const msg_event of msg_events) {
    events.push(msg_event.event);
  }
  return events;
};

/* Get event for any mtype */
export const getMsgEvent = (mtype: string): string => {
  const msg_events = msgEvents;
  let event = 'unknown';
  const i = msg_events.findIndex((e) => e.mtypes.includes(mtype));
  if (i > -1) {
    event = msg_events[i].event;
  }
  return event;
};
